import { InjectionToken } from '@angular/core';

export interface IConfigManagerServiceConfiguration {
  configFileUrl: string;
}

export const CONFIG_MANAGER_SERVICE_CONFIGURATION =
  new InjectionToken<IConfigManagerServiceConfiguration>( 'config-manager-service-configuration.config' );
